import { createContext } from 'react';
export const approvalContext = /*#__PURE__*/createContext(undefined);
export default approvalContext;